module.exports = __webpack_public_path__ + "static/CleanAir-Mobile-Header-1080x550-Curve-News-2x-1-287af382db9f793f620ba5466d733aa4.png";